import React from "react";
import { Link } from "react-router-dom";

const AboutOne = ({ services, data }) => {
  return (
    <div className="about-area-1 space-bottom space-top ">
      <div className="about1-shape-img shape-mockup">
        <img
          className="about1-shape-img-1 spin"
          src="assets/img/normal/about_shape1-2.svg"
          alt="Fixturbo"
        />
        <img
          className="about1-shape-img-2 spin2"
          src="assets/img/normal/about_shape1-1.svg"
          alt="Fixturbo"
        />
      </div>
      <div className="container">
        <div className="row gx-60 align-items-center">
          <div className="col-xl-6">
            <div className="about-thumb1 mb-40 mb-xl-0">
              <div className="about-img-1">
                <img
                  style={{ width: "420px", height: "320px" }}
                  src={
                    data.main_image
                      ? data.main_image
                      : "assets/img/hero/about_1-1.png"
                  }
                  alt="Image"
                />
              </div>
              <div className="about-img-2">
                <img
                  src={
                    data.bottom_image
                      ? data.bottom_image
                      : "assets/img/hero/about_1-2.png"
                  }
                  style={{ width: "410px", height: "277px" }}
                  alt="Image"
                />
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="about-content-wrap">
              <div className="title-area me-xl-5 mb-20">
                <span className="sub-title">Know About Us</span>
                <h2 className="sec-title">
                  {data?.title}
                </h2>
                <p className="sec-text">
                 {data?.subtitle}
                </p>
              </div>
              <div className="row gy-4 justify-content-xl-between justify-content-end align-items-center flex-row-reverse">
                <div className="col-lg-auto">
                  <div className="about-year-wrap">
                    <div
                      className="about-year-mask-wrap"
                      style={{
                        maskImage: "url(assets/img/bg/about_counter-bg1-1.png)",
                      }}
                    >
                      <img
                        src="assets/img/icon/about_icon2-1.svg"
                        alt="Fixturbo"
                      />
                      <h3 className="about-year-wrap-title">
                        <span className="counter-number">{data.clients_number ? data.clients_number : "0"}</span>+
                      </h3>
                      <p className="about-year-wrap-text">Happy Clients</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-auto col-lg-6">
                  <div className="checklist">
                    <ul>
                      {services.map((service, index) => (
                        <li key={index}>
                          <i className="fas fa-check-circle" />
                          <span
                            dangerouslySetInnerHTML={{ __html: service.text }}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutOne;
